<template>

	<section id="Analysis">

		<div id="DidYouKnow">

			<div class="dyk-toggle" :class="{show: showDidYouKnowToggle}">

				<img :src="getDYK()" alt="Did you know?" v-on:click="showDidYouKnow = !showDidYouKnow" />

			</div>

			<div class="dyk-popup" :class="{show: showDidYouKnow}">

				<div class="dyk-popup__title">

					{{ $t('analysingEvenSmDetails') }}

				</div>

				<div class="dyk-popup__text">

					{{ $t('withXray') }}

				</div>

				<div class="dyk-popup__link">

					<a id="DYKLink" @click="showImagePopup = true">

						{{ $t('discover') }}

					</a>

				</div>

			</div>

		</div>

		<div id="Model"></div>

		<Popup
			:width="activePopup.width"
			:height="activePopup.height"
			:type="activePopup.type"
			:title="activePopup.title"
			:text="activePopup.text"
			:left="activePopup.left"
			:top="activePopup.top"
			:image="activePopup.image"
			:video="activePopup.video"
			:direction="activePopup.direction"
			bgcolor="#1d8acb"
		></Popup>

		<div id="VideoPopup" v-if="showVideoPopup" style="background-color: #1d8acb;">

			<video controls autoplay>

				<source :src="activePopup.video" />

			</video>

			<img class="close" @click="showVideoPopup = false" src="/image/close.png" alt="Close" />

		</div>

		<div id="ImagePopup" v-if="showImagePopup">

			<img class="popup-image" :src="imagePopup()" alt="Popup" />

			<img class="close" src="/image/close.png" alt="Close" @click="showImagePopup = false" />

		</div>

	</section>

</template>

<script>

	import Model from "../../model";
	import Popup from "../Popup";
	import i18n from '@/plugins/i18n';

	export default {
		data () {
			return {
				activePopup: {
					id: null,
					width: 0,
					height: 0,
					type: null,
					title: null,
					text: null,
					image: '',
					video: '',
					left: 0,
					top: 0,
					direction: ''
				},
				showImagePopup: false,
				showVideoPopup: false,
				showDidYouKnowToggle: false,
				showDidYouKnow: false,
				popups: [
					{
						id: 'A',
						width: 970,
						height: 580,
						type: 'horizontal',
						title: this.$t('roughnessAnalysis'),
						text: this.$t('surfaceRoughness'),
						image: '/image/analysis/roughness_analysis.jpg',
						video: ''
					},
					{
						id: 'B',
						width: 980,
						height: 660,
						type: 'horizontal',
						title: this.$t('analysisGrainSize'),
						text: this.$t('grainSizeAndDistribution'),
						image: '/image/analysis/analysis_of_grain_size_and_dist.jpg',
						video: ''
					},
					{
						id: 'C',
						width: 930,
						height: 650,
						type: 'vertical',
						title: this.$t('nSituAnalysis'),
						text: this.$t('withNSituAnalysis'),
						image: '/image/analysis/in_situ_4d_analysis.jpg',
						video: ''
					},
					{
						id: 'D',
						width: 790,
						height: 650,
						type: 'vertical',
						title: this.$t('structuralAnalysis'),
						text: this.$t('structureCharacterization'),
						image: '/image/analysis/structural.png',
						video: '/image/analysis/structural.mp4'
					}
				]
			};
		},
		mounted () {
			Model.startAnalysis(this.onClick);
			setTimeout(() => this.showDidYouKnowToggle = true, 500);
		},
		methods: {
			imagePopup() {
				return '/image/xrayseries/systems/1.'+i18n.locale+'.png';
			},
			onClick (hotspot) {

				if (event.target.id === 'DYKLink') {
					return;
				}

				this.showDidYouKnow = false;
				let tm = this.activePopup.direction === '' ? 0 : 500;

				if (event.target.id === 'showVideoPopup') {
					return;
				}

				this.activePopup = {
					id: null,
					width: this.activePopup.width,
					height: this.activePopup.height,
					type: null,
					title: null,
					text: null,
					image: '',
					video: '',
					left: this.activePopup.left,
					top: this.activePopup.top,
					direction: ''
				};

				if (hotspot === null) {
					return;
				}

				setTimeout(() => {
					for (let popup of this.popups) {
						if (popup.id === hotspot.name) {
							this.activePopup = popup;
							let direction = '';

							if (hotspot.position.y >= 540) {
								direction = 'top';
							} else {
								direction = 'bottom';
							}

							if (hotspot.position.x >= 960) {
								direction += 'left';
							} else {
								direction += 'right';
							}

							this.activePopup.left = hotspot.position.x;
							this.activePopup.top = hotspot.position.y;
							this.activePopup.direction = direction;
						}
					}
				}, tm);
			},
			startPopupVideo () {
				if (this.activePopup.video !== '') {
					this.showVideoPopup = true;
				}
			},
			getDYK () {

				return `/image/dyk-lightblue.${ i18n.locale }.png`;
				
			}
		},
		components: {
			Popup
		}
	};

</script>
